import HomeBanner from "../../banner/HomeBanner";
import { Outlet, Link, useSearchParams } from "react-router-dom";
import ExpertProductList from "./ExpertProductList";


 // 종합대행 / 블로그 / 플레이스/ 쇼핑/ 카페 / 검색어광고 /  SNS / 인플루언서 / 언론뉴스기사 / 기타
const EXPERT_LABELS = [
    {value: '', name: '전체'},
    {value: 'PCA02', name: '종합대행'},
    {value: 'PCA03', name: '블로그'},
    {value: 'PCA04', name: '플레이스'},
    {value: 'PCA05', name: '쇼핑'},
    {value: 'PCA08', name: '카페'},
    {value: 'PCA10', name: '검색어광고'},
    {value: 'PCA11', name: 'SNS'},
    {value: 'PCA12', name: '인플루언서'},
    {value: 'PCA13', name: '언론뉴스기사'},
    {value: 'PCA99', name: '기타'}
]


const Expert = () => {
    const [searchParams] = useSearchParams();
    const isFavoriteOnly = searchParams.get('isFavoriteOnly') === 'true';
    console.log('isFavoriteOnly', isFavoriteOnly);
    return (
        <div className="vh-content">
            {/* <HomeBanner hideSideBanner={true} /> */}
            <Outlet />
            {isFavoriteOnly 
                ? <ExpertProductList key={'favoriteOnly'} title={'찜한 상품'} categories={EXPERT_LABELS} isFavoriteOnly={true}/>
                : <ExpertProductList key={'expertService'} title={'전문가 서비스'} categories={EXPERT_LABELS} isFavoriteOnly={false}/> 
            }
        </div>
    )
}

export default Expert;
export { EXPERT_LABELS };